import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import * as _ from 'lodash-es';
import { ProjectService } from 'src/app/services/project.service';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete, MatOptgroup, MatOption } from '@angular/material/autocomplete';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-autocomplete-filter-colors-groups',
    templateUrl: './autocomplete-filter-colors-groups.component.html',
    styleUrls: ['./autocomplete-filter-colors-groups.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatLabel, MatInput, FormsModule, MatAutocompleteTrigger, ReactiveFormsModule, RxReactiveFormsModule, MatAutocomplete, MatIcon, NgClass, MatOptgroup, MatOption, MatError, TranslatePipe]
})
export class AutocompleteFilterColorsGroupsComponent implements OnInit, OnDestroy {
    protected cd = inject(ChangeDetectorRef);
    protected s_project = inject(ProjectService);

    groupOptions: any;

    readonly label = input<string>();
    readonly error = input<string>();
    readonly keyGroup = input<string>();
    readonly placeholder = input<string>();
    readonly required = input<boolean>();
    readonly control = input<FormControl>();
    readonly filterKey = input<string | string[]>('');
    readonly options = input<any[] | null>();

    source: any[] | null;
    isLastItems: boolean = false;

    currentPage: number = 0;
    private readonly step: number = 20;

    private sub: Subscription = new Subscription();
    lastValue: string | undefined = undefined;

    getPaginateItems(items: { slug: string, value: string; }[], currentIndex: number, lastIndex: number) {
        if (currentIndex >= items.length || currentIndex < 0 || lastIndex < 0) {
            return [];
        } else {
            this.isLastItems = lastIndex >= items.length;
            let a = items.slice(
                currentIndex,
                lastIndex > items.length ? items.length : lastIndex
            );
            return a;
        }
    }

    plus() {
        if (!this.isLastItems) {
            this.currentPage = this.currentPage + 1;
            this.lastValue = undefined;
        }
    }

    minus() {
        if (this.currentPage - 1 >= 0) {
            this.currentPage--;
            this.lastValue = undefined;
        }
    }

    reset() {
        this.currentPage = 0;
    }

    displayWith = (value: any) => {
        if (value) {
            return typeof value === 'string' ? value : this.accessor(value);
        } else {
            console.log('ERROR : Autocomplete no value');
            return '';
        }
    };


    ngOnInit() {
        const options = this.options();
        if (options) {
            this.source = this.s_project.makeSourcePantone(options);
        }

        this.groupOptions = this._filterGroup('');
        this.sub.add(
            this.control()!.valueChanges.subscribe((value) => {
                if (value !== this.lastValue) {
                    if (this.lastValue !== undefined) {
                        this.reset();
                    }
                    this.groupOptions = this._filterGroup(value || '');
                    this.lastValue = value;
                }
            })
        );
        // this.cd.detectChanges();
    }

    private _filterGroup(value: any): any {
        if (this.source) {
            let currentInterSectionIndex = this.currentPage * this.step;
            let currentInterSectionEnd = this.currentPage * this.step + this.step;
            let array = this._filter(this.source, value);
            array = this.getPaginateItems(array, currentInterSectionIndex, currentInterSectionEnd);
            let lastCategorie: string | undefined = undefined;
            let finalArray = [];
            let finalArrayIndex = -1;
            for (let item of array) {
                if (lastCategorie !== item.slug) {
                    finalArrayIndex = finalArrayIndex + 1;
                    lastCategorie = item.slug;
                    finalArray[finalArrayIndex] = { title: item.slug, colors: [] };
                }
                (finalArray[finalArrayIndex].colors as any[]).push(item.value);
            }
            return finalArray;
        }
        const options = this.options();
        if (options) {
            return options;
        }
    }

    private _filter = (opt: { slug: string, value: string; }[], value: any): { slug: string, value: string; }[] => {
        if (value) {
            value = _.isString(value) ? value : this.accessor(value);
            if (value) {
                const filterValue = value.toLowerCase();
                return opt.filter((item) => item.value.toLowerCase().includes(filterValue));
            } else {
                return opt;
            }

        } else {
            return opt;
        }
    };

    getLabel(option: any) {
        return _.isString(option) ? option : this.accessor(option);
    }

    accessor(option: any): string {
        const filterKey = this.filterKey();
        if (_.isArray(filterKey)) {
            let v = '';
            filterKey.forEach(
                (s) => (v = _.join([v, _.property(s)(option)], ' '))
            );
            return v;
        } else {
            return _.property(filterKey)(option) as string;
        }
    }

    displayFn(value: any) {
        return value.color;
    }


    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
}
